(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pink-diamonds-landing"] && !Shopify.designMode) return;
  try {
    
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const delay = el.dataset.animDelay || 0;
        setTimeout(() => el.classList.add('is-visible'), Number(delay));
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.pdl-anim').forEach((el, i) => {
    const siblings = el.parentElement.querySelectorAll('.pdl-anim');
    const idx = Array.from(siblings).indexOf(el);
    el.dataset.animDelay = idx * 120;
    observer.observe(el);
  });

  } catch(e) { console.error(e); }
})();
})();
